// extracted by mini-css-extract-plugin
module.exports = {"details":"ProjectPortfolioDetails_details__1ASfc"};